import { gql } from '@apollo/client';

export const myCompanies = gql`
    query NE_MyCompanies($transactorId: Int!) {
        organisations: palmoil_transactor_organisation(where:{
            transactor_id: {_eq: $transactorId},
            _or: [
              {organisation: {organisation_type: {_eq: "mill"}}}
            ]
            organisation: {deleted_at: {_is_null: true}}
        }){
            transactor {
                person_id
            }
            organisation {
                id,
                organisation_type,
                location {
                    id,
                    village,
                    province
                   },
                positionepsg4326,
                name,
                reputation_level,
                employees {
                    transactor {
                        person {
                               firstname
                           }
                    }
                }
            }
}
}`

export const MillPolygon = gql`
  query NE_millPolygon($inputId: Int!) {
    coords: niaga_working_polygon(input: $inputId)
}
`

export const myAdminCompanies = gql`
    query NE_MyAdminCompanies($transactorId: Int!) {
        organisations: palmoil_transactor_organisation(where:{
            transactor_id: {_eq: $transactorId},
            _or: [
              {organisation: {organisation_type: {_eq: "conglomerate"}}}
            ]
            organisation: {deleted_at: {_is_null: true}}
        }){
            transactor {
                person_id
            }
            organisation {
                id,
                organisation_type,
                location {
                    id,
                    village,
                    province
                   },
                positionepsg4326,
                name,
                reputation_level,
                employees {
                    transactor {
                        person {
                               firstname
                           }
                    }
                }
            }
}
}`

export const myCompaniesV2 = gql`
    query NE_MyCompaniesV2($transactorId: Int!) {
        organisations: palmoil_transactor_organisation(where:{
            transactor_id: {_eq: $transactorId},
            _or: [
              {organisation: {organisation_type: {_eq: "mill"}}},
              {organisation: {organisation_type: {_eq: "conglomerate"}}}
            ]
            organisation: {deleted_at: {_is_null: true}}
        }){
            transactor {
                person_id
            }
            organisation {
                id,
                organisation_type,
                location {
                    id,
                    village,
                    province
                   },
                positionepsg4326,
                name,
                reputation_level,
                employees {
                    transactor {
                        person {
                               firstname
                           }
                    }
                }
            }
}
}`

export const myCompaniesContract = gql`
    query NE_MyCompaniesContract($transactorId: Int!) {
        organisations: palmoil_transactor_organisation(where:{
            transactor_id: {_eq: $transactorId},
            _or: [
              {organisation: {organisation_type: {_eq: "mill"}}}
            ]
            organisation: {deleted_at: {_is_null: true}}
        }){
            transactor {
                person_id
            }
            organisation {
                id,
                organisation_type,
                location {
                    id,
                    village,
                    province
                   },
                positionepsg4326,
                name,
                apply_vat,
                reputation_level,
                employees {
                    transactor {
                        person {
                               firstname
                           }
                    }
                }
            }
}
}`


export const removePersonFromCompany = gql`
mutation NE_RemovePersonFromCompany(
  $transactorId: Int!,
  $organisationId: Int!,
) {
  delete_palmoil_transactor_organisation(where: {transactor_id: {_eq: $transactorId}, organisation_id: {_eq: $organisationId}})
  {
    returning {
      organisation_id
      organisation {
        employees {
          transactor_id
          transactor {
            person {
              firstname
              lastname
              user {
                avatar_url
                email
              }
              location {
                id
                village
              }
            }
          }
        }
    }
    }
  }

  delete_palmoil_organisation_permissions_request(
      where: {
          transactor_id: {_eq: $transactorId},
          organisation_id: {_eq: $organisationId}
      }
  ){
      affected_rows
  }
}`

export const getGroupListForOrg = gql`
  query NE_getGroupListForOrg($organisationId: Int!) {

      groups: niaga_groups_organisation_list_export(filter: {organisation_id: $organisationId}) {
            group_id
            organisation_id
            group_name
            group_delta_boost
      }
}`

export const getMyGroups = gql`
query NE_GetMyGroups {
  groups: niaga_my_groups {
    buyer_organisation_id
    id
    land_plot_id
    name
    status
  }
}`

export const updateGroupPrice = gql`
mutation NE_UpdateGroupPrice($price: Int!, $group_id: Int!) {
  niaga_upsert_bid_delta_group(input: {delta_price: $price, group_id: $group_id})
}`

export const updateGroupPricePrivacy = gql`
mutation NE_updateGroupPricePrivacy($input: [niaga_group_set_privacy_input], $orgId: Int!, $namPrivacy: Boolean!) {
  niaga_group_set_privacy(input: $input)
  niaga_toggle_nam(input: {organisation_id: $orgId, is_enabled: $namPrivacy})
}`

export const getOrganisationProfileDetail = gql`
query NE_getOrganisationProfileDetail($organisationId: Int!, $transactorId: Int!) {

    groups: niaga_groups_organisation_list_export(filter: {organisation_id: $organisationId}) {
          group_id
          organisation_id
          group_name
          is_public
    }

    organisation: palmoil_transactor_organisation(where: {organisation_id: {_eq: $organisationId}, transactor_id: {_eq: $transactorId}}) {
      control_org
      organisation {
      id
      buyer {
        niaga_at_mill_enabled
      }
      organisation_type
      positionepsg4326
      reputation_level
      location {
        id
        village
        district
        subdistrict
        province
      }
      name
      apply_vat
      is_withholding_tax
      tax_identification_number
      address
      legal_name
      rt
      rw
      email
      vat_transaction_type
      legal_location {
        id
        village
        district
        subdistrict
        province
      }
      postal_code
      phonenumber
    }
    }
  }`

export const getTransactorOrganisationDetail = gql`
query NE_GetTransactorOrganisationDetail($organisationId: Int!, $transactorId: Int!) {

    groups: niaga_groups_organisation_list_export(filter: {organisation_id: $organisationId}) {
      group_id
      organisation_id
      group_name
      plots {
        id
        polygon
        name
        size
        owner {
          id
          user {
            avatar_url
          }
          firstname
          lastname
        }
      }
    }

    organisation: niaga_get_my_mills(filter : { organisation_id: $organisationId, transactor_id: $transactorId}) {
      control_org
      employees {
        person_id
        transactor_id
        first_name
        last_name
        avatar_uri
        location {
          id
          village
        }
      }

      grading {
        cardinality
        grading
        grading_name
      }
      mill {
          rt
          rw
          apply_vat
          tax_identification_number
          address
          postal_code
          phonenumber
        organisation {
          id
          type
          position {
            coordinates
          }
          name
        }
      }
    }
  }
`

export const MyProfile = gql`
  query NE_MyProfile($userId: String!) {
    person: palmoil_person(where: {user: {id: {_eq: $userId}}}) {
      firstname
      lastname
      user {
        avatar_url
      }
    }
  }`


export const GetActiveContracts = gql`
  query NE_NiagaContractsActive($market_day: date!, $market_day_end: date!) {
    palmoil_sale(where:{_and:[
      {transport_crew_contract_sales:{transport_crew_contract:{market_day:{_gte:$market_day}}}},
      {transport_crew_contract_sales: {transport_crew_contract: {market_day: {_lte:$market_day_end}}}},
      {transport_crew_contract_sales: {party: {_eq: "buyer"}}},
      {transport_crew_contract_sales: {transport_crew_contract: {canceled_at: {_is_null: true}}}}
    ],
    _or: [{transport_crew_contract_sales: {transport_crew_contract: {status: {_eq: "OPEN"}}}},
      {transport_crew_contract_sales: {transport_crew_contract: {status: {_eq: "OPEN_DELIVERED"}}}}
      ]}){
         id
         status: transaction_state
          sale_invoice_item{
            invoice_id
          }
          sale_items{
            id
            quantity
            price_per_quantity_unit
            updated_at
            created_at
            product{
              sku
            }
          }
        transport_crew_contract_sales{
          transport_crew_contract_id
          sale_statement {
            id
          }
          transport_crew_contract{
            market_day
            contract_type
          }
      }
    }
}`

export const GetCompletedContract = gql`
query NE_NiagaContractsCompleted(
  $orgId: Int!
  $market_day: date!
  $market_day_end: date!
) {
  palmoil_transport_crew_contract_sale(
    where: {
      _and: [
        { sale: { buyer_organisation_id: { _in: [$orgId] } } }
        {
          _or: [
            { transport_crew_contract: { status: { _eq: "completed" } } }
            { transport_crew_contract: { status: { _eq: "COMPLETED" } } }
            { transport_crew_contract: { status: { _eq: "OPEN_DELIVERED" } } }
          ]
        }
        { transport_crew_contract: { market_day: { _gte: $market_day } } }
        { transport_crew_contract: { market_day: { _lte: $market_day_end } } }
      ]
    }
  ) {
    id
    transport_crew_contract_id
    sale_statement {
      id
      line_items {
        quantity
        price_per_unit
        updated_at
        created_at
        product {
          sku
          category
        }
      }
    }
    transport_crew_contract {
      market_day
      contract_type
      status
    }
  }
}`

export const GetHarvestInfosExport = gql`
query NE_GetHarvestInfosExport($contracts: [Int!]!) {
  niaga_contract_list_export(filter: {contract_ids: $contracts}) {
    items {
      contract_id
      market_day
      net_quantity
      transporter {
        id
        transactor {
           person {
             firstname
             lastname
           }
         }
      }
      harvests {
        fruit_pile_uri
        fruit_bunch_uri
        fruit_pile_position
        quantity
        loaded_quantity
        farmer {
          organisation {
            id
            name
            location {
              id
              village
              subdistrict
              district
              province
            }
          }
        }
        land_plot {
          id
          polygon
          size
          pickup_position
          polygon
        }
      }
    }
  }
}
`

export const GetNAFV3Contract = gql`
query NE_niagaNafV3Details($statementId: Int!) {
  contract: naf_contract_detail(statement_id: $statementId) {
    transporter {
      person {
        first_name
        last_name
        location {
          village
          district
          subdistrict
          province
        }
      }
    }
    statement {
      id
      total_amount
      total_amount_due
      line_items {
        sku
        total
        quantity
        price_per_unit
      }
      photos {
        uri
        type
        position {
          coordinates
        }
      }
    }
    harvests {
      land_plot {
        id
        name
        polygon {
          coordinates
        }
      }
      id
      photos {
        uri
        type
        position {
          coordinates
        }
      }
    }
    contract_id
    market_day
    type
    status
    buyer {
      organisation {
        name
        id
      }
    }
  }
}
`

export const GetHakamContract = gql`
query NE_niagaAgentFarmerContractDetails($statementId: Int!) {
  contract: niaga_agent_seller_contract_detail(
    filter: {statement_id: $statementId}
  ) {
    contract_id
    status
    market_day
    sellers {
      party_context {
        transactor {
          person {
            location {
              village
              district
            }
            firstname
            lastname
            user {
              avatar_url
            }
          }
        }
      }
    }
    statement {
      statement {
        id
        state
        status
        total
        tax_total
        pre_tax_total
        photos {
          photo {
            type
            uri
            created_at
          }
        }
        line_items {
          sku
          total
          quantity
          price_per_unit
          line_item_sale_item_static_description {
            title
          }
        }
      }
    }
    primary_buyer {
      party_context {
        organisation {
          id
          name
        }
      }
    }
    harvests {
      id
      photoCollection {
        type
        uri
        created_at
      }
      fruit_bunch_uri
      fruit_pile_uri
      loaded_quantity
      land_plot {
        id
        polygon
        name
      }
    }
  }
}
`

export const GetNiagaContract = gql`
query NE_niagaPrimaryBuyerContractById($statementId: Int!) {
  contract: niaga_contract_detail(filter: {statement_id: $statementId}) {
      contract_id
      statement_id
      status
      market_day
      harvests {
        id
        photos {
          photo {
            type
            uri
          }
        }
        quantity
        land_plot {
          id
          name
          polygon
          pickup_position
        }
      }
      statement {
          statement {
            id
            state
            status
            total
            tax_total
            pre_tax_total
            photos {
              photo {
                type
                uri
                created_at
              }
            }
            line_items {
              sku
              total
              quantity
              price_per_unit
              line_item_sale_item_static_description {
                title
              }
            }
          }
      }
      primary_buyer  {
        party_context {
          transactor {
            person {
              firstname
              lastname
              user {
                avatar_url
              }  
            }
          }
          organisation {
            id
            name
          }
        }
      }
      transporter {
          party_context {
              transactor {
                person {
                  firstname
                  lastname
                  location {
                    village
                    district
                  }  
                  user {
                    avatar_url
                  }  
                }
              }
              organisation_id
          }
      }
  }
}
`

export const getContractAgent = gql`
query NE_GetAgentContract($statementId: Int!) {
  contract: niaga_agent_contract_detail(filter: { statement_id: $statementId }) {
    contract_id
    status
    market_day
    harvests {
      photos {
        photo {
          type
          uri
        }
      }
      quantity
      land_plot {
        id
        name
        polygon
        pickup_position
      }
    }
    statement {
      sale_statement_id
      statement {
        id
        state
        status
        total
        tax_total
        pre_tax_total
        photos {
          photo {
            type
            uri
          }
        }
        line_items {
          sku
          total
          quantity
          price_per_unit
          line_item_sale_item_static_description {
            title
          }
        }
      }
    }
    agent {
      party_context {
        transactor {
          person {
            firstname
            lastname
            location {
              village
              district
            }  
            user {
              avatar_uri
            }
          }
        }
      }
    }
    primary_buyer {
      party_context {
        organisation {
          id
          name
        }
      }
    }
  }
}
`

export const UpdateOrganisation = gql`
  mutation NE_UpdateOrganisation($organisationId: Int!, $object: palmoil_organisation_set_input!) {
    organization: update_palmoil_organisation_by_pk(
        pk_columns: { id: $organisationId },
        _set: $object
    ) {
        id
    }
}`


export const UpsertBid = gql`
mutation NE_UpsertNiagaBid($input: niaga_upsert_bid_input!) {
  bid: niaga_upsert_bid(input: $input) {
    organisation_id
    bids {
      market_day
      price_per_kg
      updated_at
      updated_by
    }
  }
}`

export const GetBids = gql`
query NE_NiagaBuyerBid {
  bids: niaga_bid {
    organisation_id
    bids {
      id
      market_day
      price_per_kg
      updated_at
      updated_by
    }
    grading {
      cardinality
      grading
      grading_name
    }
  }
}`

export const getPerson = gql`
query NE_getPerson($email: String) {
  persons: palmoil_person(where: {user: {email: {_eq: $email}}}) {
    __typename
    id
    firstname
    lastname
    transactor {
      id
    }
    user {
      avatar_url
      email
    }
    location {
      id
      village
    }
  }
}`


// INVITATION
export const getInvitedUserQuery = gql`
query NE_GetInvitedUserQuery($orgId: Int!) {
  users: palmoil_invitation(where: {inviter_organisation_id: {_eq: $orgId}}) {
    email
    firstname
    lastname
  }
}`


export const createInvitationMutation = gql`
mutation NE_CreateInvitationMutation($object: palmoil_invitation_insert_input!) {
  user: insert_palmoil_invitation_one(object: $object, on_conflict:{constraint:unique_email_organisation, update_columns: [firstname, lastname]}) {
    email
    __typename
  }
}`

export const updateInvitationMutation = gql`
mutation NE_UpdateInvitationMutation($object: palmoil_invitation_set_input!, $email: String!, $orgId: Int!, $oob: String!) {
  user: update_palmoil_invitation(_set: $object, where: {email: {_eq: $email}, inviter_organisation_id: {_eq: $orgId}, oob: {_eq: $oob}}){
    returning {
      status
    }
  }
}`

export const removeInvitationMutation = gql`
mutation NE_RemoveInvitationMutation($email: String!, $orgId: Int!) {
  delete_palmoil_invitation(where: {email: {_eq: $email}, inviter_organisation_id: {_eq: $orgId}}) {
    returning {
      status
    }
  }
}`

export const reinviteMutation = gql`
mutation NE_ReinviteMutation($email: String!, $orgId: Int!, $userInfo: palmoil_invitation_insert_input!) {
  delete_palmoil_invitation(where: {email: {_eq: $email}, inviter_organisation_id: {_eq: $orgId}}) {
    returning {
      status
    }
  }

  user: insert_palmoil_invitation_one(object: $userInfo){
    email
  }
}`

export const SearchLocation = gql`
query NE_SearchLocation($locationText: String!){
  locations: palmoil_search_location(args: {search: $locationText}, limit: 20){
    id
    village
    district
    subdistrict
    province
  }
}`

export const FetchProfile = gql`
query NE_FetchProfile($userId: String!) {
    person: palmoil_person(where: {user: {id: {_eq:$userId}}}){
        firstname
        lastname
        nickname
        phones {
            id
            phonenumber
        }
        user {
            email
            avatar_uri
            avatar_url
        }
        location {
          id
          village
          district
          subdistrict
          province
        }
    }
}`

export const UpdateProfile = gql`
mutation NE_UpdateProfile(
  $personId: Int!
  $person: palmoil_person_set_input!
) {
  person: update_palmoil_person_by_pk(pk_columns: { id: $personId }, _set: $person){
      id
  }
}`

export const CreateInvoice = gql`
mutation NE_CreateInvoice($data: [palmoil_invoice_item_insert_input!]!) {
  insert_palmoil_invoice_one(object:{invoice_items:{data:
    	$data
  	}}){
    id
  }
}
`

export const FetchOnboardedFarmers = gql`
query NE_FetchOnboardedFarmers($distinct: palmoil_land_plot_select_column!) {
  farmers: palmoil_land_plot(where: {affiliate_reward_program_participant: {_is_null: false}}, distinct_on: [$distinct]) {
    created_at
    owner_person_id
    external_id
    name
    owner {
      firstname
      lastname
      location {
        province
        subdistrict
        district
        village
      }
    }
  }

  landplots: palmoil_land_plot(where: {affiliate_reward_program_participant: {_is_null: false}}, order_by: {created_at: desc}) {
    created_at
    owner_person_id
    owner {
      location {
        province
        subdistrict
        district
        village
      }  
    }
  }
}`

export const GetSaleFromContract = gql`
query GetSaleFromContract($id: Int!) {
  palmoil_sale(where: {transport_crew_contract_sales: {transport_crew_contract: {id: {_eq: $id}}}}) {
    transport_crew_contract_sales {
      sale_id
      transport_crew_contract {
        contract_type
      }
    }
  }
}
`

export const createQBP = gql`
mutation NE_createQBP($input: niaga_add_grading_group_metadata_input!) {
  niaga_add_grading_group_metadata(
    input: $input
  )
}`

export const deleteQBP = gql`
mutation NE_deleteQBP($id: Int!) {
  niaga_clear_quality_based(organisation_id: $id)
}
`

export const upsertQBP = gql`
mutation NE_upsertQBP($input: niaga_upsert_quality_based_input!) {
  niaga_upsert_quality_based(
    input: $input
  ) {
    grading {
      cardinality
      grading
      grading_name
    }
  }
}`